import type { components, paths } from "@securityjourney/svc-audit/audit";

import { OpenApiFetchWrapper } from "./openApiFetchWrapper";

export type AuditEvent = components["schemas"]["securityjourney.proto.audit.AuditEvent"];
export type AuditRedactionRequest =
  components["schemas"]["securityjourney.proto.audit.AuditRedactionRequest"];
export type TenantAuditRedaction =
  components["schemas"]["securityjourney.proto.audit.TenantAuditRedaction"];
export type ListEventsResponse =
  components["schemas"]["securityjourney.proto.audit.ListEventsResponse"];
export type ListRedactionsResponse =
  components["schemas"]["securityjourney.proto.audit.ListRedactionsResponse"];
export type RedactUserRequest =
  components["schemas"]["securityjourney.proto.audit.RedactUserRequest"];
export type RedactUserResponse =
  components["schemas"]["securityjourney.proto.audit.RedactUserResponse"];
export type AuditTaxonomy =
  components["schemas"]["securityjourney.proto.audit.GetTaxonomyResponse"];

export type AuditPersonRole = "PERSON_ROLE_ACTOR" | "PERSON_ROLE_SUBJECT";

export type ListEventsOptions = NonNullable<
  paths["/svc/audit/{tenant}/events"]["get"]["parameters"]["query"]
>;
export type ListRedactionsOptions = NonNullable<
  paths["/svc/audit/redactions"]["get"]["parameters"]["query"]
>;

class AuditClient extends OpenApiFetchWrapper<paths> {
  async getTaxonomy() {
    return await this.get("/svc/audit/taxonomy");
  }
  async listEvents(tenant: string, options?: ListEventsOptions) {
    return await this.get("/svc/audit/{tenant}/events", {
      params: {
        path: { tenant },
        query: options,
      },
    });
  }
  async listRedactions(options?: ListRedactionsOptions) {
    return await this.get("/svc/audit/redactions", { params: { query: options } });
  }
  async getRedaction(requestId: string) {
    return await this.get("/svc/audit/redactions/{requestId}", {
      params: { path: { requestId } },
    });
  }
  async redactUser(request: RedactUserRequest) {
    return await this.post("/svc/audit/redactions", { body: request });
  }
}

let auditClientInstance: AuditClient | null = null;

export const getAuditClient = (): AuditClient => {
  if (!auditClientInstance) {
    auditClientInstance = new AuditClient();
  }
  return auditClientInstance;
};
